(function () {
  function initAnchors(scope) {
    var links = scope.querySelectorAll('[data-vg-hbl-event="inline-cta-clicked"][href^="#vg-hbl-"]');
    links.forEach(function (link) {
      if (link.getAttribute('data-vg-hbl-anchor-ready') === 'true') return;
      link.setAttribute('data-vg-hbl-anchor-ready', 'true');
      link.addEventListener('click', function (event) {
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        var selector = link.getAttribute('href');
        var target = selector ? document.querySelector(selector) : null;
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', selector);
      });
    });
  }

  function initReviewGallery(gallery) {
    if (!gallery || gallery.dataset.vgHblReady === 'true') return;
    gallery.dataset.vgHblReady = 'true';

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-vg-hbl-revgal-slide]'));
    var previous = gallery.querySelector('[data-vg-hbl-revgal-prev]');
    var next = gallery.querySelector('[data-vg-hbl-revgal-next]');
    var dotsRoot = gallery.querySelector('[data-vg-hbl-revgal-dots]');
    var index = 0;
    var touchStart = null;

    if (!slides.length) return;

    if (slides.length < 2) {
      if (previous) previous.hidden = true;
      if (next) next.hidden = true;
    }

    slides.forEach(function (_, slideIndex) {
      if (!dotsRoot || slides.length < 2) return;
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'vg-hbl-revgal__dot';
      dot.setAttribute('aria-label', 'Show review ' + (slideIndex + 1) + ' of ' + slides.length);
      dot.addEventListener('click', function () { show(slideIndex, 'dot'); });
      dotsRoot.appendChild(dot);
    });

    function show(nextIndex, source) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) { slide.hidden = slideIndex !== index; });
      if (dotsRoot) {
        Array.prototype.forEach.call(dotsRoot.children, function (dot, dotIndex) {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
      }
      gallery.dispatchEvent(new CustomEvent('vg-hbl:reason-review-navigation', {
        bubbles: true,
        detail: { index: index, source: source }
      }));
    }

    if (previous) previous.addEventListener('click', function () { show(index - 1, 'previous'); });
    if (next) next.addEventListener('click', function () { show(index + 1, 'next'); });

    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1, 'keyboard'); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1, 'keyboard'); }
    });

    gallery.addEventListener('touchstart', function (event) {
      touchStart = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : null;
    }, { passive: true });

    gallery.addEventListener('touchend', function (event) {
      if (touchStart === null || !event.changedTouches || !event.changedTouches[0]) return;
      var distance = event.changedTouches[0].clientX - touchStart;
      touchStart = null;
      if (Math.abs(distance) < 40) return;
      show(index + (distance < 0 ? 1 : -1), 'swipe');
    }, { passive: true });

    show(0, 'initial');
  }

  function initReviewGalleries(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-vg-hbl-revgal]'), initReviewGallery);
  }

  function init() {
    initAnchors(document);
    initReviewGalleries(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
